<template>
  <div class="bottom_container">
    <div class="indexBottom">
      <el-row>
        <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">
          <img src="@/assets/images/logo2.png" class="logo_img">
        </el-col>
        <el-col :xs="{span:24,offset:1}" :sm="{span:9,offset:1}" :md="{span:10,offset:1}" :lg="{span:10,offset:1}" :xl="{span:10,offset:1}" class="contact">
          <div class="left_show">
            <div class="bottom_title">联系我们</div>
            <div class="bottom_title_Eng">CONTACT US</div>
          </div>
          <div class="right_show">
            <p>联系电话：021-5856-3033</p>
            <p>公司地址：中国（上海）自由贸易试验区世纪大道1600号7层1-2，6A单元</p>
            <p>网站负责人邮箱：zhujj@zz-med.com</p>
            <!--<p>公司产品：<span style="margin-left: 5px"><a href="https://zz-med-stg-pub.oss-cn-hangzhou.aliyuncs.com/mmc_ditui/20200902/SaasDataService.msi">SaasDataService</a></span>-->
            <!--<span style="margin-left: 10px"><a href="https://zz-med-stg-pub.oss-cn-hangzhou.aliyuncs.com/mmc_ditui/20200902/EzCapture.exe">EzCapture</a></span>-->
            <!--<span style="margin-left: 10px"><a href="http://download-zz-med-test.oss-cn-hangzhou.aliyuncs.com/Zz_Saas_Desktop_App/Zz_Saas_Desktop_App_1.0.0.5.zip  ">智众医信桌面端</a></span></p>-->
          </div>
        </el-col>
        <el-col :xs="{span:24,offset:2}" :sm="{span:9,offset:1}" :md="8" :lg="8" :xl="8">
          <div class="left_show">
            <div class="bottom_title">关注我们</div>
            <div class="bottom_title_Eng">FOCUS US</div>
          </div>
          <div class="right_show">
            <img src="@/assets/images/foot_qr1.png" class="qr_code">
            <img src="@/assets/images/item/foot_qr_ihec.png" v-if="showQR2">
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="bottom_copyright">
      <div class="copyright_container">
        <span class="right_show">  <a target="_blank" style="color: #1d2124"  href="https://beian.miit.gov.cn/">沪ICP备13045286号-2</a></span>
        <span class="right_show">ICP许可证：合字B2-20250469</span>
        <span class="right_show">药品、医疗器械互联网信息服务备案：沪网药信备字〔2025〕00198 号</span>
      </div>
      <div class="copyright_container">
        <span class="left_show">Copyright © 2019-2020 Shanghai Zhizhong Medical Technology Co., Ltd.  All Rights Reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      showQR2:false
    }
  },
  mounted(){

  },
  watch:{
    '$route'(){
      this.showQR2 = this.$route.path=='/itemIHEC'
    }
  },
}
</script>

<style lang="less" scoped>
.bottom_container{
  .indexBottom{
    background-color: #fff;
    border-top: 1px solid #dcdcdc;
    padding: 20px;
    .el-row{
      max-width: 1170px;
      margin: 0 auto;
      .logo_img{
        width: 147px;
      }
      .el-col{
        margin-top: 7px;
        overflow: hidden;
        .left_show,.right_show{
          float: left;
          .bottom_title{
            font-size: 16px;
            font-weight: 600;
          }
          .bottom_title_Eng{
            color: #b0b0b0;
            font-size: 12px;
          }
        }
        .left_show{
          margin-right: 20px;
        }
        &.contact{
          .right_show {
            margin-top: -5px;
            p{
              line-height: 30px;
              font-size: 14px;
              letter-spacing: 0;
            }
          }
        }
      }
    }
  }
  .bottom_copyright{
    font-size: 14px;
    width: 100%;
    background-color: #ececec;
    .copyright_container{
      max-width: 1170px;
      margin: 0 auto;
      padding: 9px 0;
      overflow: hidden;
      text-align: center;
      .right_show{
        margin: 0 15px;
      }
    }
  }
}
</style>
